
import { Component, Vue, Prop } from "vue-property-decorator";

import {
  getOrderList,
  getGrabOrderList,
  exportImage,
  exportEorder,
  exportOrderList,
  delOrderService,
  reallyDelete,
  orderFinish,
  batchOrderServiceOrderClose,
  assignOrders,
  batchOrderServiceOrderSettle,
} from "@/api/orderService";
import { UserModule } from "@/store/modules/user";
import eventBus from "@/utils/eventBus";
import { ViewType, OrderServiceStage } from "@/types/orderServicer";
import { IPagination } from "@/types";
import { isEmpty } from "@/utils";

import BbsDialog from "@/components/BbsDialog/index.vue";
import DialogImgLarge from "@/components/ImgLarge/index.vue";
import DialogOrderDetail from "@/components/OrderDetail/index.vue";
import buttonList from "@/components/OrderServiceButtonList/index.vue";
import columnItem from "./OrderColumnItem.vue";
import columnItemLatest from "./OrderColumn.vue";
import DialogOrderProcess from "./OrderProcessDialog.vue";

import {
  checkPermissionCompanyFromOrderType,
  checkPermissionCompany,
  checkPermissionRole,
} from "@/utils/permission";
import { Type } from "../../../types/permissionType";
import { getVariousTagsList } from "@/api/allTags";
import Index from "@/components/Breadcrumb/index.vue";
import { getTaskProgressList } from "@/api/orderTask";

@Component({
  name: "orderServicerList",
  components: {
    DialogImgLarge,
    DialogOrderDetail,
    BbsDialog,
    buttonList,
    columnItem,
    columnItemLatest,
    Index,
    DialogOrderProcess,
  },
})
export default class extends Vue {
  private listLoading = false;
  private orderList: any = [];
  private permissionType = Type;
  @Prop({
    default: "",
    type: String,
  })
  private orderId!: "";
  @Prop({
    default: false,
    type: Boolean,
  })
  private isRefuseAcceptComplete!: boolean;
  @Prop({
    default: OrderServiceStage.SERVICE_STAGE,
    validator: (value) => OrderServiceStage !== undefined,
  })
  private stage!: OrderServiceStage;

  @Prop({
    default: OrderServiceStage.SERVICE_STAGE_SUB_NULL,
    validator: (value) => OrderServiceStage !== undefined,
  })
  private stageSub!: OrderServiceStage;

  @Prop({
    default: OrderServiceStage.SERVICE_STAGE_SUB_NULL,
    validator: (value) => OrderServiceStage !== undefined,
  })
  private status?: OrderServiceStage;

  @Prop({
    default: ViewType.ORDER_SERVICER,
    validator: (value) => ViewType !== undefined,
  })
  private viewType?: ViewType;

  private isSendEng = false;

  private timeOutOrderTab = this.stage;
  // 2进行中 3上报 4挂单 5转出单 6已完成 7已关闭

  private settlementType = 0;

  private checkedOnlyMine = false;
  private checkedOnlyMe() {
    this.getList();
  }

  private checkedNoSerDept = false;
  private checkedNoSerDeptHandle() {
    this.searchParams = {
     ...this.searchParams,
     'servicer_dept_id':"0,",
    };
    this.getList();
  }

  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };

  // private maxHeight = window.innerHeight - 120
  private orderSelected: any = [];
  private orderSelectedId: any = [];

  private orderSelectedAll = false;
  private isIndeterminate: any = null;

  private outsourceType = "1";

  private checkPermissionCompanyFromOrderType(
    companyId: string,
    permission: Type,
    orderType: any
  ) {
    return checkPermissionCompanyFromOrderType(
      companyId,
      permission,
      orderType
    );
  }
  private checkPermissionUser(companyId: string, permission: Type) {
    return checkPermissionRole(companyId, permission);
  }
  private checkPermissionCompany(companyId: string, permission: Type) {
    return checkPermissionCompany(companyId, permission);
  }

  private handleCheckAllChange(val: boolean) {
    for (let i = 0; i < this.orderList.length; i++) {
      let index = this.orderSelectedId.findIndex((or: any) => {
        return or === this.orderList[i].order.id;
      });
      if (this.viewType === 2 && this.isEvalueOrDel === 1) {
        if (
          parseInt(this.orderList[i].order_service.state) >= 771 &&
          parseInt(this.orderList[i].order_service.state) <= 880 &&
          this.orderList[i].order_service.evaluate_state !== "1"
        ) {
          if (val) {
            if (index === -1) {
              this.orderSelected.push(this.orderList[i]);
              this.orderSelectedId.push(this.orderList[i].order.id);
            }
          } else {
            if (index !== -1) {
              this.orderSelected.splice(index, 1);
              this.orderSelectedId.splice(index, 1);
            }
          }
        }
      } else {
        if (val) {
          if (index === -1) {
            this.orderSelected.push(this.orderList[i]);
            this.orderSelectedId.push(this.orderList[i].order.id);
          }
        } else {
          if (index !== -1) {
            this.orderSelected.splice(index, 1);
            this.orderSelectedId.splice(index, 1);
          }
        }
      }
    }
    this.isIndeterminate = false;
  }
  private handleCheckedOrderChange(checked: boolean, val: any) {
    let index = this.orderSelected.findIndex((ss: any) => {
      return ss.order.id === val.order.id;
    });
    if (checked) {
      if (index === -1) {
        this.orderSelected.push(val);
      }
    } else {
      if (index !== -1) {
        this.orderSelected.splice(index, 1);
      }
    }
    // let checkedCount = val.length;
    // let _length = this.orderList.length;
    // this.orderSelectedAll = checkedCount === _length;
    // this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }
  private searchParams: any = {};
  created() {
    this.timeOutOrderTab = this.stage;
    this.getColumnItem();
    let that = this;
    eventBus.$on("orderServicerOrderSearch", (data: any) => {
      that.searchParams = data;
      that.pagination.currentPage = 1;
      let val: any = that.$route.query.CustomeRelatedOrder_jump_CUS
        ? JSON.parse(that.$route.query.CustomeRelatedOrder_jump_CUS as string)
        : "";
      if (!that.searchParams.customer_company_id && val && val.id) {
        let customerId = "";
        if (parseInt(val.customer_type) === 1) {
          customerId = val.customer_company_id;
        } else {
          customerId = "p" + val.customer_user_id;
        }
        that.searchParams.customer_company_id = customerId;
      }
      //取消无服务部门条件
      this.checkedNoSerDept = false;
      that.getList();
    });

    if (
      this.viewType === ViewType.ORDER_SERVICER_RECYCLE ||
      this.viewType === ViewType.ORDER_SERVICER_REPORT ||
      this.viewType === ViewType.ORDER_SERVICER_HANG
    ) {
      this.columnItemIsHidden = true;
    }

    //结算管理 区分是未结算还是已结算
    if (this.$route.path === '/Settlement/unsettled') {
      this.settlementType = 1;
    }else if (this.$route.path === '/Settlement/settled'){
      this.settlementType = 2;
    }
    // alert( this.settlementType)
  }

  beforeDestroy() {
    // 在离开页面的时候注销掉该eventBus的事件，否则会在多个页面中重复请求
    eventBus.$off("orderServicerOrderSearch");
  }
  private timeOutOrderTabChange(val: any) {
    this.getList();
  }
  private refreshList() {
    this.getList();
  }

  private getCheckBoxDisable(row: any) {
    let disable = false;
    disable =
      this.viewType === 2 && this.isEvalueOrDel === 1
        ? !(
            parseInt(row.order_service.state) >= 771 &&
            parseInt(row.order_service.state) <= 880 &&
            row.order_service.evaluate_state !== "1"
          )
        : false;
    return disable;
  }

  /**
   * 获取订单列表
   */
  getList() {
    this.orderSelectedAll = false;
    this.isIndeterminate = false;
    this.orderList = [];
    this.listLoading = true;
    let params: any = {
      platform_type: "user",
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      stage: this.viewType === 10 ? this.timeOutOrderTab : this.stage,
      stage_sub: this.stageSub,
      is_need_task: 1,
      need_score: 1,
      ...this.searchParams,
    };
    if (this.viewType === 11) {
      params.create_user_id = UserModule.getUserId;
      params.create_company_id = UserModule.getCompanyId;
    }
    if (this.viewType === 12) {
      params.is_relation_customer_order = 1;
    }
    //如果是结算管理必须有费用
    if (this.viewType === 23) {
      params.price_state = 1;
      if(this.settlementType === 1){
        params.is_settle = 0;
      }else if(this.settlementType === 2){
        params.is_settle = 1;
      }
    }
    if (this.searchParams.stage_sub_search) {
      params.stage_sub = this.searchParams.stage_sub_search;
    } else {
      params.stage_sub = this.stageSub;
    }
    if (this.viewType === ViewType.ORDER_SERVICER_COMPLETED || this.viewType === ViewType.ORDER_SERVICER_COMPLETED_SETTLE) {
      params.is_show_charge_off = 1;
    }
    if (this.ascendingOrder) {
      params.order_sort = "addtime asc";
    }
    if (this.isRefuseAcceptComplete) {
      params.is_refuse_accept_complete = "1";
    }
    if (this.descendingOrder) {
      params.order_sort = "addtime desc";
    }
    params.myself_dispose = this.checkedOnlyMine ? "1" : "0";
    // if (this.viewType === ViewType.ORDER_SERVICER_GRAB) {
    //   params.order_type = '1,2,3';
    // }
    if (
      this.status !== "" &&
      this.status !== OrderServiceStage.SERVICE_STATUS_GRAB
    ) {
      params.status = this.status;
    }
    if (this.status === OrderServiceStage.SERVICE_STATUS_GRAB) {
      getGrabOrderList(params)
        .then((res) => {
          const data = res.data;
          if (data && data.list) {
            if (data.count) {
              this.pagination.total = data.count || 0;
            }
            this.orderList = data.list;
          } else {
            this.pagination.total = 0;
            this.orderList = [];
          }
          this.listLoading = false;
        })
        .catch((err) => {
          this.pagination.total = 0;
          this.listLoading = false;
          let msg = err.msg;
        });
    } else {
      params.repair_order_id = this.orderId;
      getOrderList(params)
        .then((res) => {
          const data = res.data;
          if (data && data.list) {
            if (data.count) {
              this.pagination.total = data.count || 0;
            }
            this.orderList = data.list;
          } else {
            this.pagination.total = 0;
            this.orderList = [];
          }
          this.listLoading = false;
        })
        .catch((err) => {
          this.pagination.total = 0;
          this.listLoading = false;
          let msg = err.msg;
        });
    }
  }

  private ascendingOrder = false;
  private descendingOrder = false;
  private sortCommandHandle(command: any) {
    if (command === "default") {
      this.ascendingOrder = !this.ascendingOrder;
    } else if (command === "ascending") {
      this.ascendingOrder = !this.ascendingOrder;
      this.descendingOrder = !this.descendingOrder;
    } else {
      this.ascendingOrder = !this.ascendingOrder;
      this.descendingOrder = !this.descendingOrder;
    }
    this.getList();
  }

  private columnItem: any = {
    trouble_describle: { name: "故障信息", value: "0", checked: true },
    phenomenon_describle: { name: "故障现象", value: "13", checked: true },
    transfer_in: { name: "转入方", value: "11", checked: false },
    customer: { name: "报修方", value: "1", checked: true },
    mobile: { name: "联系方式", value: "2", checked: true },
    servicer: { name: "服务方", value: "22", checked: true },
    progress: { name: "订单进度", value: "3", checked: false },
    status: { name: "订单状态", value: "4", checked: true },
    label: { name: "标签", value: "5", checked: false },
    device: { name: "设备/型号/SN号", value: "6", checked: false },
    price: { name: "费用", value: "7", checked: false },
    real_price: { name: "实际", value: "8", checked: false },
    evaluate: { name: "评价状态", value: "9", checked: false },
    addtime: { name: "报修时间", value: "14", checked: true },
    operate: { name: "操作", value: "10", checked: true },
    hangTime: { name: "处理人/挂单时间", value: "12", checked: false },
  };

  private columnItemIsHidden = false;

  getTagsHtml(r: any) {
    let kind = "";
    let kindType = "";
    let abnormal = "";
    let plain = "plain";
    if (parseInt(r.order.order_type) === 1) {
      kind = "其他";
      kindType = "warning";
    } else if (parseInt(r.order.order_type) === 2) {
      kind = "维保";
      kindType = "success";
    } else if (parseInt(r.order.order_type) === 3) {
      kind = "安装";
      kindType = "danger";
    } else if (parseInt(r.order.order_type) === 4) {
      kind = "巡检";
      kindType = "";
      if (parseInt(r.order_service.polling_check_abnormal_count) > 0) {
        abnormal = "巡异";
      }
    } else {
      kind = "维保";
      kindType = "success";
    }

    let source = "";
    if (r.order.customer_company_id === r.order_service.servicer_company_id) {
      source = "内部";
    } else {
      source = "外部"; 
    }
    if (parseInt(r.order_service.transfer_in) === 1) {
      source = "转入";
    }
    if (parseInt(r.order_service.transfer_out) === 1) {
      source = "转出";
    }

    let charge = "";
    let darkplain = "dark";
    if (parseInt(r.order_service.charge) === 1) {
      charge = "收费";
    }

    let expedited = "";
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = "加急";
    } 

    // 2019-05-23 迭代 订单排位
    let ranking = "";
    if (parseInt(r.order_service.is_ranking) === 1) {
      let rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + "号";
      }
    }

    // 审核标识
    let check = "";
    if (
      parseInt(r.order.check_state) === 11 ||
      parseInt(r.order.check_state) === 51
    ) {
      check = "审核";
    }

    // 留言
    let mesg = "";
    if (r.order.new_bbs_content.id) {
      mesg = "have";
    }

    if (r.order.is_new_bbs) {
      mesg = "new";
    }

    // 超时标识
    let timeout = "";
    if (
      parseInt(r.order_service.is_timeout) === 1
    ) {
      timeout = "超时";
    }

    return [
      {
        type: "",
        label: source,
        plain: darkplain,
      },
      {
        type: kindType,
        label: kind,
        plain: plain,
      },
      {
        type: "danger",
        label: abnormal,
        plain: darkplain,
      },
      {
        type: "danger",
        label: charge,
        plain: darkplain,
      },
      {
        type: "danger",
        label: expedited,
        plain: darkplain,
      },
      {
        type: "danger",
        label: ranking,
        plain: darkplain,
      },
      {
        type: "warning",
        label: check,
        plain: darkplain,
      },
      {
        type: "danger",
        label: timeout,
        plain: darkplain,
      },
    ];
  }

  get tableDataColumnListNumber() {
    let num: number = 0;
    for (let i in this.columnItem) {
      if (this.columnItem[i].checked === true && !this.columnItem[i].hide) {
        num++;
      }
    }
    return num + 2;
  }

  arraySpanMethod(IOrderColspan: any) {
    if (IOrderColspan.columnIndex === 0) {
      return [1, this.tableDataColumnListNumber];
    } else {
      return [0, 0];
    }
  }

  private getColumnItem() {
    if (this.viewType !== ViewType.ORDER_SERVICER_HANG) {
      this.columnItem.hangTime.hide = true;
    }
    if (this.viewType === ViewType.ORDER_SERVICER_HANG) {
      // 挂单
      this.columnItem.hangTime.checked = true;
      this.columnItem.status.checked = false;
    }

    if (this.viewType !== ViewType.ORDER_SERVICER_TRANSFER) {
      this.columnItem.transfer_in.hide = true;
    }
    if (this.viewType === ViewType.ORDER_SERVICER_TRANSFER) {
      // 转单
      this.columnItem.real_price.hide = true;
      this.columnItem.evaluate.hide = true;

      this.columnItem.transfer_in.checked = true;
    }

    if (this.viewType === ViewType.ORDER_SERVICER_UNTREATED) {
      // 待处理
      this.columnItem.price.hide = true;
      this.columnItem.real_price.hide = true;
      this.columnItem.evaluate.hide = true;

      this.columnItem.progress.checked = true;
      this.columnItem.status.checked = false;
    }
    if (this.viewType === ViewType.ORDER_SERVICER_UNDERWAY) {
      // 进行中
      this.columnItem.label.hide = true;
      this.columnItem.device.hide = true;
      this.columnItem.evaluate.hide = true;

      this.columnItem.progress.checked = true;
      this.columnItem.status.checked = false;
    }
    if (this.viewType === ViewType.ORDER_SERVICER_COMPLETED || this.viewType === ViewType.ORDER_SERVICER_COMPLETED_SETTLE) {
      // 已完成
      this.columnItem.label.hide = true;
      this.columnItem.device.hide = true;

      this.columnItem.progress.checked = true;
      this.columnItem.status.checked = false;
      this.columnItem.evaluate.checked = true;
    }

    if (
      this.viewType === ViewType.ORDER_SERVICER_RECYCLE ||
      this.viewType === ViewType.ORDER_SERVICER_REPORT
    ) {
      this.columnItem.progress.checked = true;
      this.columnItem.status.checked = false;
    }
    if (this.viewType === ViewType.ORDER_SERVICER_COMPLETED_SETTLE) {
      this.columnItem.price.hide = true;
      this.columnItem.real_price.hide = true;
    }
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index,
    };
    this.$store.dispatch("toggleEnlarged", enlargedData);
  }
  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }
  // 右上角导出
  private exportExcel() {
    if (
      (!this.searchParams.start_time || !this.searchParams.end_time) &&
      (!this.searchParams.finish_start_time ||
        !this.searchParams.finish_end_time)
    ) {
      this.showErrorMsg("请选择开始时间和结束时间，搜索之后导出");
      return;
    }
    if (
      this.searchParams.finish_end_time ||
      this.searchParams.finish_start_time
    ) {
      if (
        parseInt(this.searchParams.end_time) -
          parseInt(this.searchParams.start_time) >
        (31 * 24 + 24) * 60 * 60
      ) {
        if (!this.searchParams.finish_end_time) {
          this.showErrorMsg("请选择完结日期结束时间");
          return;
        }
        if (!this.searchParams.finish_start_time) {
          this.showErrorMsg("请选择完结日期开始时间");
          return;
        }
        if (
          parseInt(this.searchParams.finish_end_time) -
            parseInt(this.searchParams.finish_start_time) >
            (31 * 24 + 24) * 60 * 60 &&
          parseInt(this.searchParams.end_time) -
            parseInt(this.searchParams.start_time) >
            (31 * 24 + 24) * 60 * 60
        ) {
          this.showErrorMsg("最多选择一个月数据导出");
          return;
        }
      }
    } else if (
      parseInt(this.searchParams.end_time) -
        parseInt(this.searchParams.start_time) >
      (31 * 24 + 24) * 60 * 60
    ) {
      this.showErrorMsg("最多选择一个月数据导出");
      return;
    }
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      stage: this.viewType === 10 ? this.timeOutOrderTab : this.stage,
      stage_sub: this.stageSub,
      ...this.searchParams,
    };
    if (this.viewType === 11) {
      pamars.create_user_id = UserModule.getUserId;
      pamars.create_company_id = UserModule.getCompanyId;
    }
    //如果是结算管理必须有费用
    if (this.viewType === 23) {
      pamars.price_state = 1;
      if(this.settlementType === 1){
        pamars.is_settle = 0;
      }else if(this.settlementType === 2){
        pamars.is_settle = 1;
      }
    }
    pamars.type =
      this.viewType === ViewType.ORDER_SERVICER_ALL
        ? "all"
        : this.viewType === ViewType.ORDER_SERVICER_UNTREATED
        ? "untreated"
        : this.viewType === ViewType.ORDER_SERVICER_UNDERWAY
        ? "underway"
        : this.viewType === ViewType.ORDER_SERVICER_COMPLETED
        ? "finish"
        : this.viewType === ViewType.ORDER_SERVICER_COMPLETED_SETTLE
        ? "finish"
        : this.viewType === ViewType.ORDER_SERVICER_REPORT
        ? "appear"
        : this.viewType === ViewType.ORDER_SERVICER_HANG
        ? "hang"
        : this.viewType === ViewType.ORDER_SERVICER_RECYCLE
        ? "recycle"
        : "";
    if (this.viewType === ViewType.ORDER_SERVICER_RECYCLE) {
      pamars.status = -1;
    }
    exportOrderList(pamars)
      .then((res: any) => {
        if (res) {
          this.showSecussMsg(res.msg);
          this.$confirm("是否跳转下载页面？", "跳转", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let routeData = this.$router.resolve({
                path: "/ExportTask",
                query: {},
              });
              window.open(routeData.href);
            })
            .catch(() => {});
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private exportEOrder() {
    if (
      (!this.searchParams.start_time || !this.searchParams.end_time) &&
      (!this.searchParams.finish_start_time ||
        !this.searchParams.finish_end_time)
    ) {
      this.showErrorMsg("请选择开始时间和结束时间，搜索之后导出");
      return;
    }
    if (
      this.searchParams.finish_end_time ||
      this.searchParams.finish_start_time
    ) {
      if (
        parseInt(this.searchParams.end_time) -
          parseInt(this.searchParams.start_time) >
        (31 * 24 + 24) * 60 * 60
      ) {
        if (!this.searchParams.finish_end_time) {
          this.showErrorMsg("请选择完结日期结束时间");
          return;
        }
        if (!this.searchParams.finish_start_time) {
          this.showErrorMsg("请选择完结日期开始时间");
          return;
        }
        if (
          parseInt(this.searchParams.finish_end_time) -
            parseInt(this.searchParams.finish_start_time) >
            (31 * 24 + 24) * 60 * 60 &&
          parseInt(this.searchParams.end_time) -
            parseInt(this.searchParams.start_time) >
            (31 * 24 + 24) * 60 * 60
        ) {
          this.showErrorMsg("最多选择一个月数据导出");
          return;
        }
      }
    } else if (
      parseInt(this.searchParams.end_time) -
        parseInt(this.searchParams.start_time) >
      (31 * 24 + 24) * 60 * 60
    ) {
      this.showErrorMsg("最多选择一个月数据导出");
      return;
    }
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      ...this.searchParams,
    };
    if (this.viewType === 11) {
      pamars.create_user_id = UserModule.getUserId;
      pamars.create_company_id = UserModule.getCompanyId;
    }
    exportEorder(pamars)
      .then((res: any) => {
        if (res) {
          this.showSecussMsg(res.msg);
          this.$confirm("是否跳转下载页面？", "跳转", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let routeData = this.$router.resolve({
                path: "/ExportTask",
                query: {},
              });
              window.open(routeData.href);
            })
            .catch(() => {});
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private exportIMG() {
    if (
      (!this.searchParams.start_time || !this.searchParams.end_time) &&
      (!this.searchParams.finish_start_time ||
        !this.searchParams.finish_end_time)
    ) {
      this.showErrorMsg("请选择开始时间和结束时间，搜索之后导出");
      return;
    }
    if (
      this.searchParams.finish_end_time ||
      this.searchParams.finish_start_time
    ) {
      if (
        parseInt(this.searchParams.end_time) -
          parseInt(this.searchParams.start_time) >
        (31 * 24 + 24) * 60 * 60
      ) {
        if (!this.searchParams.finish_end_time) {
          this.showErrorMsg("请选择完结日期结束时间");
          return;
        }
        if (!this.searchParams.finish_start_time) {
          this.showErrorMsg("请选择完结日期开始时间");
          return;
        }
        if (
          parseInt(this.searchParams.finish_end_time) -
            parseInt(this.searchParams.finish_start_time) >
            (31 * 24 + 24) * 60 * 60 &&
          parseInt(this.searchParams.end_time) -
            parseInt(this.searchParams.start_time) >
            (31 * 24 + 24) * 60 * 60
        ) {
          this.showErrorMsg("最多选择一个月数据导出");
          return;
        }
      }
    } else if (
      parseInt(this.searchParams.end_time) -
        parseInt(this.searchParams.start_time) >
      (31 * 24 + 24) * 60 * 60
    ) {
      this.showErrorMsg("最多选择一个月数据导出");
      return;
    }
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      stage: this.viewType === 10 ? this.timeOutOrderTab : this.stage,
      stage_sub: this.stageSub,
      image_type: 11,
      ...this.searchParams,
    };
    if (this.viewType === 11) {
      pamars.create_user_id = UserModule.getUserId;
      pamars.create_company_id = UserModule.getCompanyId;
    }
    exportImage(pamars)
      .then((res: any) => {
        if (res) {
          this.showSecussMsg(res.msg);
          this.$confirm("是否跳转下载页面？", "跳转", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let routeData = this.$router.resolve({
                path: "/ExportTask",
                query: {},
              });
              window.open(routeData.href);
            })
            .catch(() => {});
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private exportOrderPollingIMG() {
    if (
      (!this.searchParams.start_time || !this.searchParams.end_time) &&
      (!this.searchParams.finish_start_time ||
        !this.searchParams.finish_end_time)
    ) {
      this.showErrorMsg("请选择开始时间和结束时间，搜索之后导出");
      return;
    }
    if (
      this.searchParams.finish_end_time ||
      this.searchParams.finish_start_time
    ) {
      if (
        parseInt(this.searchParams.end_time) -
          parseInt(this.searchParams.start_time) >
        (31 * 24 + 24) * 60 * 60
      ) {
        if (!this.searchParams.finish_end_time) {
          this.showErrorMsg("请选择完结日期结束时间");
          return;
        }
        if (!this.searchParams.finish_start_time) {
          this.showErrorMsg("请选择完结日期开始时间");
          return;
        }
        if (
          parseInt(this.searchParams.finish_end_time) -
            parseInt(this.searchParams.finish_start_time) >
            (31 * 24 + 24) * 60 * 60 &&
          parseInt(this.searchParams.end_time) -
            parseInt(this.searchParams.start_time) >
            (31 * 24 + 24) * 60 * 60
        ) {
          this.showErrorMsg("最多选择一个月数据导出");
          return;
        }
      }
    } else if (
      parseInt(this.searchParams.end_time) -
        parseInt(this.searchParams.start_time) >
      (31 * 24 + 24) * 60 * 60
    ) {
      this.showErrorMsg("最多选择一个月数据导出");
      return;
    }
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      stage: this.viewType === 10 ? this.timeOutOrderTab : this.stage,
      stage_sub: this.stageSub,
      image_type: 21,
      ...this.searchParams,
    };
    if (this.viewType === 11) {
      pamars.create_user_id = UserModule.getUserId;
      pamars.create_company_id = UserModule.getCompanyId;
    }
    exportImage(pamars)
      .then((res: any) => {
        if (res) {
          this.showSecussMsg(res.msg);
          this.$confirm("是否跳转下载页面？", "跳转", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let routeData = this.$router.resolve({
                path: "/ExportTask",
                query: {},
              });
              window.open(routeData.href);
            })
            .catch(() => {});
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private exportReturnVisit() {
    if (
      (!this.searchParams.start_time || !this.searchParams.end_time) &&
      (!this.searchParams.finish_start_time ||
        !this.searchParams.finish_end_time)
    ) {
      this.showErrorMsg("请选择开始时间和结束时间，搜索之后导出");
      return;
    }
    if (
      this.searchParams.finish_end_time ||
      this.searchParams.finish_start_time
    ) {
      if (
        parseInt(this.searchParams.end_time) -
          parseInt(this.searchParams.start_time) >
        (31 * 24 + 24) * 60 * 60
      ) {
        if (!this.searchParams.finish_end_time) {
          this.showErrorMsg("请选择完结日期结束时间");
          return;
        }
        if (!this.searchParams.finish_start_time) {
          this.showErrorMsg("请选择完结日期开始时间");
          return;
        }
        if (
          parseInt(this.searchParams.finish_end_time) -
            parseInt(this.searchParams.finish_start_time) >
            (31 * 24 + 24) * 60 * 60 &&
          parseInt(this.searchParams.end_time) -
            parseInt(this.searchParams.start_time) >
            (31 * 24 + 24) * 60 * 60
        ) {
          this.showErrorMsg("最多选择一个月数据导出");
          return;
        }
      }
    } else if (
      parseInt(this.searchParams.end_time) -
        parseInt(this.searchParams.start_time) >
      (31 * 24 + 24) * 60 * 60
    ) {
      this.showErrorMsg("最多选择一个月数据导出");
      return;
    }
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      ...this.searchParams,
    };
    if (this.viewType === 11) {
      pamars.create_user_id = UserModule.getUserId;
      pamars.create_company_id = UserModule.getCompanyId;
    }
    pamars.type = "returnVisit";
    exportOrderList(pamars)
      .then((res: any) => {
        if (res) {
          this.showSecussMsg(res.msg);
          this.$confirm("是否跳转下载页面？", "跳转", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let routeData = this.$router.resolve({
                path: "/ExportTask",
                query: {},
              });
              window.open(routeData.href);
            })
            .catch(() => {});
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 左上批量删除
  private plText = "确认批量评价";
  private isEvalueOrDel: number = 0;
  private handleEvalueate(val: any) {
    this.isEvalueOrDel = parseInt(val);
    this.plText = "确认批量评价";
    this.orderSelected = [];
    this.orderSelectedId = [];
    this.orderSelectedAll = false;
    this.isIndeterminate = false;
  }
  private handleDel(val: any) {
    this.isEvalueOrDel = parseInt(val);
    this.plText = "确认批量删除";
    this.orderSelected = [];
    this.orderSelectedId = [];
    this.orderSelectedAll = false;
    this.isIndeterminate = false;
  }
  private confirmPlBtn() {
    switch (this.isEvalueOrDel) {
      case 1:
        this.evaluateOrder();
        break;
      case 2:
        if (!this.orderSelected || this.orderSelected.length < 1) {
          this.showErrorMsg("请选择需要批量删除的订单");
          return;
        }
        this.dialogDeletefirmNextVisible = true;

        break;
    }
  }
  private evaluateOrder() {
    if (!this.orderSelected || this.orderSelected.length < 1) {
      this.showErrorMsg("请选择需要批量评价的订单");
      return;
    }
    let arr:any=[];
    this.orderSelected.filter((order1: any) => {
      arr = this.orderSelected.filter((order: any) => {
        return order.order_service.is_open_diy_evaluate !== order1.order_service.is_open_diy_evaluate;
      });
    });
    if (arr && arr.length > 0) {
      this.showErrorMsg("请选择相同评价");
      return;
    }
    if(parseInt(this.orderSelected[0].order_service.is_open_diy_evaluate)===1){
      this.$router.push({
        path: "/OrderServicer/evaluation",
        query: {
          orderList: JSON.stringify(this.orderSelected),
          isPL: "1",
        },
      });
    }else{
      this.$router.push({
      path: "/OrderServicer/evaluate",
      query: {
        orderList: JSON.stringify(this.orderSelected),
        isPL: "1",
      },
    });
    }
  }
  // 删除
  private deleteOrderHandle() {
    if (!this.orderSelected || this.orderSelected.length < 1) {
      this.showErrorMsg("请选择需要批量删除的订单");
      return;
    }
    this.dialogDeletefirmNextVisible = true;
  }
  private dialogDeletefirmNextVisible = false;
  private delConfirm() {
    this.deleteOrder();
  }
  private async deleteOrder() {
    this.dialogDeletefirmNextVisible = false;
    this.dialogProgressVisible = true;
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
    };

    this.num = 0;
    this.failNum = 0;
    for (let index = 0; index < this.orderSelected.length; index++) {
      let arrIds = [];
      arrIds.push(this.orderSelected[index].order_service.id);
      if (this.viewType === 2) {
        pamars.order_service_id = this.orderSelected[index].order_service.id;
        await delOrderService(pamars)
          .then((res: any) => {
            this.num = this.num + 1;
            if (this.num + this.failNum === this.orderSelected.length) {
              this.showSecussMsg(res.msg);
              this.dialogProgressVisible = false;
              this.getList();
            }
          })
          .catch((err) => {
            this.failNum = this.failNum + 1;
            if (this.num + this.failNum === this.orderSelected.length) {
              this.dialogProgressVisible = false;
              this.getList();
            }
            let msg = err.msg;
          });
      } else {
        pamars.id = arrIds;
        await reallyDelete(pamars)
          .then((res: any) => {
            this.num = this.num + 1;
            if (this.num + this.failNum === this.orderSelected.length) {
              this.dialogProgressVisible = false;
              this.showSecussMsg(res.msg);
              this.getList();
            }
          })
          .catch((err) => {
            let msg = err.msg;
            this.failNum = this.failNum + 1;
            if (this.num + this.failNum === this.orderSelected.length) {
              this.dialogProgressVisible = false;
              this.getList();
            }
          });
      }
    }
  }
  private closeOrder() {
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
    };
    if (this.formGroupConfirm.type && this.formGroupConfirm.type.id) {
      pamars.classify_id = this.formGroupConfirm.type.id;
      pamars.classify_name = this.formGroupConfirm.type.name;
    }
    pamars.remark = this.formGroupConfirm.content;
    let arrIds = [];
    for (let index = 0; index < this.orderSelected.length; index++) {
      arrIds.push(this.orderSelected[index].order_service.id);
    }
    pamars.order_service_ids = arrIds.join(",");
    batchOrderServiceOrderClose(pamars)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.dialogGroupConfirmNextVisible = false;
        this.getList();
      })
      .catch((err: any) => {
        let msg = err.msg;
        this.dialogGroupConfirmNextVisible = false;
        this.getList();
      });
  }
  // 批量代客确认
  private focusGroupConfirmRemark() {
    let VariousTagsParam: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: 1,
      size: 999,
      type: 4,
    };
    getVariousTagsList(VariousTagsParam)
      .then((res) => {
        if (res.data) {
          this.optionsGroupConfirmRemark = res.data.list;
        } else {
          this.optionsGroupConfirmRemark = [];
        }
      })
      .catch((err: any) => {
        this.optionsGroupConfirmRemark = [];
        let msg = err.msg;

      });
  }
  private remarckGroupConfirm() {
    if (isEmpty(this.formGroupConfirm.content.trim())) {
      this.showErrorMsg("请填写备注");
      return;
    }
    this.dialogGroupConfirmVisible = false;
    this.dialogGroupConfirmNextVisible = true;
  }

  private dialogProgressVisible = false;
  private num = 0;
  private failNum: any = 0;
  private async GroupConfirm() {
    if (this.isCloseOrder === 1) {
      this.closeOrder();
    } else {
      this.num = 0;
      this.failNum = 0;
      this.dialogGroupConfirmNextVisible = false;
      this.dialogProgressVisible = true;
      for (let index = 0; index < this.orderSelected.length; index++) {
        const element: any = this.orderSelected[index];
        let pamars: any = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_id: UserModule.getCompanyId,
          order_service_id: element.order_service.id,
        };
        if (this.formGroupConfirm.type && this.formGroupConfirm.type.id) {
          pamars.classify_id = this.formGroupConfirm.type.id;
          pamars.classify_name = this.formGroupConfirm.type.name;
        }
        pamars.remark = this.formGroupConfirm.content;
        await orderFinish(pamars)
          .then((res: any) => {
            this.num = this.num + 1;
            if (this.num + this.failNum === this.orderSelected.length) {
              this.showSecussMsg(res.msg);
              this.dialogProgressVisible = false;
              this.getList();
            }
          })
          .catch((err) => {
            this.failNum = this.failNum + 1;
            if (this.num + this.failNum === this.orderSelected.length) {
              this.dialogProgressVisible = false;
              this.getList();
            }
            let msg = err.msg;
            this.showErrorMsg(msg);
          });
      }
    }
  }
  // 订单详情
  detailHandle(val: any, index: number) {
    let routeData = this.$router.resolve({
      path: "/OrderServicer/todetail",
      query: {
        order_service_id: val.order_service.id,
        company_id: val.order_service.servicer_company_id,
        viewType: this.viewType + "",
        showBJD:
          this.status === OrderServiceStage.SERVICE_STATUS_GRAB ? "0" : "1",
        tabName: "schedule",
      },
    });
    window.open(routeData.href);
  }

  // 任务详情
  private dialogOrderDetailVisible = false;
  private detail = {};
  private task = {};
  private orderProgressData = {};
  private isOrderTask = false;
  private isOrderProgress = false;
  private showComplaintBtn = false;
  private showBJD = false;
  private isOrderEnterTask = false;
  detailOrderTask(row: any, current: any, type: number) {
    this.isOrderEnterTask = true;
    this.dialogOrderDetailVisible = true;
    this.detail = row;
    this.task = current;
    this.isOrderTask = true;

    let p = {};
    (p as any).user_id = UserModule.getUserId;
    (p as any).company_id = UserModule.getCompanyId;
    (p as any).order_service_id = row.order_service.id;
    (p as any).order_id = row.order.id;
    (p as any).user_name = UserModule.getUserName;
    getTaskProgressList(p)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.orderProgressData = data;
        } else {
          this.orderProgressData = {};
        }
      })
      .catch((err) => {
        let msg = err.msg;
        this.orderProgressData = {};
      });

    if (type === 2) {
      this.isOrderProgress = true;
    } else {
      this.isOrderProgress = false;
    }
  }
  // 批量代客确认
  private dialogGroupConfirmVisible = false;
  private dialogGroupConfirmNextVisible = false;
  private formGroupConfirm: any = {
    type: "",
    content: "",
  };
  private optionsGroupConfirmRemark = [];
  private batchOrderFinish() {
    if (!this.orderSelected || this.orderSelected.length < 1) {
      this.showErrorMsg("请选择需要批量代客确认的订单");
      return;
    }
    let arr2: any = [];
    arr2 = this.orderSelected.filter((order: any) => {
      return (
        parseInt(order.order.check_state) === 11 ||
        parseInt(order.order.check_state) === 51
      );
    });
    if (arr2 && arr2.length > 0) {
      this.showErrorMsg("批量订单中有审核单");
      return;
    }
    this.isCloseOrder = 2;
    this.dialogGroupConfirmVisible = true;
  }
  private isCloseOrder = 0;
  // 批量关闭
  private batchOrderClose() {
    if (!this.orderSelected || this.orderSelected.length < 1) {
      this.showErrorMsg("请选择需要批量关闭的订单");
      return;
    }
    let arr2: any = [];
    arr2 = this.orderSelected.filter((order: any) => {
      return (
        parseInt(order.order.check_state) === 11 ||
        parseInt(order.order.check_state) === 51
      );
    });
    if (arr2 && arr2.length > 0) {
      this.showErrorMsg("批量订单中有审核单");
      return;
    }
    let arr3: any = [];
    arr3 = this.orderSelected.filter((order: any) => {
      return parseInt(order.order_service.transfer_out) === 1;
    });
    if (arr3 && arr3.length > 0) {
      this.showErrorMsg("批量订单中有转出单");
      return;
    }
    this.isCloseOrder = 1;
    this.dialogGroupConfirmVisible = true;
  }

  //结算
  private dialogSettleConfirmVisible = false;
  private formSettleConfirm: any = {
    // settle_amount: "",
    remark: "",
  };
  private batchOrderSettle() {
    if (!this.orderSelected || this.orderSelected.length < 1) {
      this.showErrorMsg("请选择需要结算的订单");
      return;
    }
    // let arr2: any = [];
    // arr2 = this.orderSelected.filter((order: any) => {
    //   return (
    //     parseInt(order.order.check_state) === 11 ||
    //     parseInt(order.order.check_state) === 51
    //   );
    // });
    // if (arr2 && arr2.length > 0) {
    //   this.showErrorMsg("批量订单中有审核单");
    //   return;
    // }
    let arr3: any = [];
    arr3 = this.orderSelected.filter((order: any) => {
      return parseInt(order.order_service.transfer_out) === 1;
    });
    if (arr3 && arr3.length > 0) {
      this.showErrorMsg("批量订单中有转出单");
      return;
    }
    this.dialogSettleConfirmVisible = true;
  }

  private batchOrderSettleConfirm(order:any) {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
    };
    params.remark = this.formSettleConfirm.remark;
    let settleArr = [];
    if(order){
      const item = {order_service_id:order.order_service.id};
      settleArr.push(item);
    }else{
      console.log(this.orderSelected);
      for (let index = 0; index < this.orderSelected.length; index++) {
        let item:any = {order_service_id:this.orderSelected[index].order_service.id};
        if(this.formSettleConfirm.settle_amount!=""){
          item.estimated_amount = this.orderSelected[index].order_service.estimated_amount;
          // item.settle_amount =  this.formSettleConfirm.settle_amount;
        }
        settleArr.push(item);
      }
    }
    params.settlement = JSON.stringify(settleArr);
    console.log(params);
    batchOrderServiceOrderSettle(params)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.getList();
        this.dialogSettleConfirmVisible = false;
      })
      .catch((err: any) => {
        let msg = err.msg;
        this.dialogSettleConfirmVisible = false;
        this.getList();
      });
  }

  
  // 工程师派单
  private orderDetail: any = {};
  private sendOrderToEng() {
    // 新版批量处理订单是弹框
    if (!this.orderSelected || this.orderSelected.length < 1) {
      this.showErrorMsg("请选择需要指派的订单");
      return;
    }
    let arr: any = [];
    this.orderSelected.filter((order1: any) => {
      arr = this.orderSelected.filter((order: any) => {
        return order.order.order_type !== order1.order.order_type;
      });
    });
    if (arr && arr.length > 0) {
      this.showErrorMsg("请选择同一订单类型的订单");
      return;
    }
    let arr2: any = [];
    arr2 = this.orderSelected.filter((order: any) => {
      return (
        parseInt(order.order.check_state) === 11 ||
        parseInt(order.order.check_state) === 51
      );
    });
    if (arr2 && arr2.length > 0) {
      this.showErrorMsg("批量订单中有审核单");
      return;
    }

    this.selectedOrderProcessVisible = true;
    this.OrderProcessType = "3";
    this.orderDetail = this.orderSelected[0];
    this.dealList = [
      {
        id: 1,
        show:
          checkPermissionCompanyFromOrderType(
            this.orderDetail.order_service.servicer_company_id,
            Type.ORDER_ASSIGN_SELF,
            this.orderDetail.order.order_type
          ) &&
          checkPermissionRole(
            this.orderDetail.order_service.servicer_company_id,
            Type.ORDER_ASSIGN_SELF
          ),
        text: "派给自己",
      },

      {
        id: 3,
        show:
          checkPermissionCompanyFromOrderType(
            this.orderDetail.order_service.servicer_company_id,
            Type.ORDER_ASSIGN,
            this.orderDetail.order.order_type
          ) &&
          checkPermissionRole(
            this.orderDetail.order_service.servicer_company_id,
            Type.ORDER_ASSIGN
          ),
        text: "分派至工程师",
      },
      {
        id: 2,
        show:
          checkPermissionCompanyFromOrderType(
            this.orderDetail.order_service.servicer_company_id,
            Type.ORDER_ASSIGN,
            this.orderDetail.order.order_type
          ) &&
          checkPermissionRole(
            this.orderDetail && this.orderDetail.order_service
              ? this.orderDetail.order_service.servicer_company_id
              : 0,
            Type.ORDER_ASSIGN
          ),
        text: "分派至部门",
      },
      {
        id: 4,
        show:
          checkPermissionCompanyFromOrderType(
            this.orderDetail.order_service.servicer_company_id,
            Type.ORDER_TRANSFER,
            this.orderDetail.order.order_type
          ) &&
          checkPermissionRole(
            this.orderDetail.order_service.servicer_company_id,
            Type.ORDER_TRANSFER
          ),
        text: "转单",
      },
      {
        id: 5,
        show:
          checkPermissionCompanyFromOrderType(
            this.orderDetail.order_service.servicer_company_id,
            Type.OrderEnquiry,
            this.orderDetail.order.order_type
          ) &&
          checkPermissionRole(
            this.orderDetail.order_service.servicer_company_id,
            Type.OrderEnquiry
          ),
        text: "分配询价",
      },
    ];
  }
  private dealList: any = [];
  // 工程师派单 新版
  private selectedOrderProcessVisible = false;
  private OrderProcessType = "2";
  private eng: any = {};
  private engDept: any = {};
  private sendOrderToEngNew() {
    // 还是之前的逻辑，先选工程师，弹框选择， 再选订单
    this.OrderProcessType = "2";
    this.selectedOrderProcessVisible = true;
  }
  private selectedOrderProcessClose(val: boolean, isReferesh: boolean) {
    this.selectedOrderProcessVisible = val;
    if (isReferesh && typeof isReferesh !== "function") {
      this.orderSelected=[]
      this.orderSelectedId=[]
      this.getList();
    }
  }
  private sendOrderNew() {
    if (!this.orderSelected || this.orderSelected.length < 1) {
      this.showErrorMsg("请选择需要指派的订单");
      return;
    }
    let arr: any = [];
    this.orderSelected.filter((order1: any) => {
      arr = this.orderSelected.filter((order: any) => {
        return order.order.order_type !== order1.order.order_type;
      });
    });
    if (arr && arr.length > 0) {
      this.showErrorMsg("请选择同一订单类型的订单");
      return;
    }
    let arr2: any = [];
    arr2 = this.orderSelected.filter((order: any) => {
      return (
        parseInt(order.order.check_state) === 11 ||
        parseInt(order.order.check_state) === 51
      );
    });
    if (arr2 && arr2.length > 0) {
      this.showErrorMsg("批量订单中有审核单");
      return;
    }
    this.sendToEng();
  }
  // 指派工程师 批量处理
  private sendToEng() {
    let serviceId = [];
    for (const key of this.orderSelected) {
      serviceId.push(key.order_service.id);
    }
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
    };
    params.order_service_id = JSON.stringify(serviceId);
    params.work_user = JSON.stringify({
      user_id: this.eng.user_id,
      name: this.eng.user_name,
    });

    if (this.engDept && this.engDept.id) {
      params.work_department_id = this.engDept.id;
      params.work_department_name = this.engDept.name;
    }
    assignOrders(params)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.orderSelected=[];
        this.orderSelectedId=[];
        this.eng = {};
        this.engDept = {};
        this.isSendEng = false;
        this.getList();
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private selectedOrderProcessData(eng: any, dept: any) {
    if (eng.user_id) {
      this.eng = eng;
      this.engDept = dept;
      this.isSendEng = true;
    }
  }

  closeDetailHandle(value: boolean) {
    this.dialogOrderDetailVisible = value;
  }

  private nowId: number = -1;
  private nowSid: number = -1;
  private bbsDialogVisible: boolean = false;
  // 不根据state判断，所以永远置为1
  private state: number = 1;

  closeBbs(value: boolean, refresh?: boolean) {
    this.bbsDialogVisible = value;
    if (refresh !== undefined && refresh) {
      this.getList();
    }
  }
  private mesgHandle(r: any) {
    this.nowId = parseInt(r.order.id);
    this.nowSid = parseInt(r.order_service.id);
    this.bbsDialogVisible = true;
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
